import { Appointment } from '@/libraries/ClassDefinitions'
import { getEmergencyDepartmentColumn } from './SpecialVisitEmergencyDepartmentCodes'; 
import { getHospitalOutPatientDepartmentColumn } from './SpecialVisitHospitalOutPatientDepartment';
import { getHospitalInDepartmentColumn } from './SpecialVisitHospitalInPatientDepartment';
import { getLongTermCareColumn }from './SpecialVisitLongTermCare';
import { getPallativeCareColumn } from './SpecialVisitPallativeCare';
import { getPatientHomeColumn } from './SpecialVisitPatientHome';
import { getPhysicianOfficeColumn } from './SpecialVisitPhysicianOffice';
import { getGeriatricColumn } from './SpecialVisitGeriatric';
import { getOtherColumn } from './SpecialVisitOther';


/**
 * THIS IS THE MAIN SCRIPT FOR ALL PREMIUM CODES
 * SPECIAL VISIT CODES ARE ALL RETURNED AND PASSED UP FROM HERE
 * COUNSELLING AND DETENTION COMPUTED HERE
 * FILES SHOULD EXPORT TO A VUE EXCEPT THIS ONE
 */


/**
 * Get the special visit codes
 * @param {Appointment} newApt 
 * @param {Appointment} timePeriodAppointments 
 */
export function getSpecialVisitCode(newApt, timePeriodAppointments){
    if (newApt.specialVisit == 'No' || !newApt.specialVisit) return [];
    const specialCodesToBeBilled = [];
    const column = getSpecialVisitColumn(newApt);
    column.forEach(codeObject => {
        codeObject.validate({
            self: codeObject,
            timePeriodAppointments: timePeriodAppointments,
            newApt: newApt,
        })
        if (codeObject.applicable){
            specialCodesToBeBilled.push({
                name: codeObject.name,
                price: codeObject.price,
                code: codeObject.code
            })
        }
    })
    return specialCodesToBeBilled;
}


/**
 * Get the appropriate special visit column for an appointment, assumes
 * specialVisit, aptDate, and time are defined. 
 * @param {Appointment} newApt 
 * @returns {Array<CodeObject>} column
 */
export function getSpecialVisitColumn(newApt){
    switch (newApt.specialVisit) {
        case 'emergency':
            return getEmergencyDepartmentColumn(newApt);
        case 'outpatient':
            return getHospitalOutPatientDepartmentColumn(newApt);
        case 'inpatient':
            return getHospitalInDepartmentColumn(newApt);
        case 'longTermCare':
            return getLongTermCareColumn(newApt);
        case 'pallativeCare':
            return getPallativeCareColumn(newApt);
        case 'patientsHome':
            return getPatientHomeColumn(newApt);
        case 'physiciansOffice':
            return getPhysicianOfficeColumn(newApt);
        case 'geriatric':
            return getGeriatricColumn(newApt);
        case 'other':
            return getOtherColumn(newApt);
        default:
            return []; // if somehow we fail, no premiums no errors
    }

}


/**
 * Get detention code(s).
 * @param {number} aptLength length of apt in minutes
 * @param {codeObject} appointmentCode 
 * @returns {Array<codeObject>} k001
 */
export function getDetention(aptLength, appointmentCode){
    if (!appointmentCode) return [];
    if (aptLength > 1000){
        alert('Put in minutes spent at appointment. Max value is 1000.')
        return [];
    }
    // K001 (q15minutes) – begins 60 minutes after start of consult and 40 minutes after assessment
    const currentCode = appointmentCode.code.substring(1); // 'A345' -> '345'
    const consultCodes = ['345', '765', '745', '346'];
    const assessmentCodes = ['343', '341', '340', '348'];

    let minTime; 
    if (consultCodes.includes(currentCode)) minTime = 60;
    else if(assessmentCodes.includes(currentCode)) minTime = 40;
    else return []; // apt code not compatible with detention

    const codeModel = [];
    if (aptLength < minTime) return []; // also handles neg numbers/0 input
    const numberOfCodesBillable = Math.floor((aptLength-minTime)/15)+1; // if minTime = 40 and len = 41 minutes, +1 makes one code billed
    for (let i = 0; i < numberOfCodesBillable; i++){
        codeModel.push({
            code:'K001',
            name: 'Detention',
            price: 21.1,
        })
    }
    return codeModel;
}